    
    export const fetchUserSuccess = user => ({
        type: 'FETCH_USER',
        payload: { user }
    })

        
 